import { gql } from '@apollo/client';
export const assetFragment = gql `
  fragment assetFields on AssetEntity {
    code
    name
    isoCode
    iconUrl
    isCrypto
    isStable
    isDisabled
    isAccountBased
  }
`;
export const partialAssetFragment = gql `
  fragment partialAssetFields on PartialAsset {
    code
    name
    iconUrl
    roundingPrecision
  }
`;
//# sourceMappingURL=asset.js.map